module.exports = __webpack_public_path__ + "static/media/veterano_b.ae63a2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/veterano_b.png
// module id = 1153
// module chunks = 0